<template>
  <div>
    <Form ref="pointForm" :model="pointForm" :rules="ruleValidate" :label-width="120">
      <FormItem label="上级考点">
        <p>{{parent_name}}</p>
      </FormItem>
      <FormItem label="考点名称" prop="name">
        <Input
          style="width:300px"
          type="text"
          v-model="pointForm.name"
          :maxlength="15"
          placeholder="考点名称最多输入15个字"
        />
      </FormItem>
      <FormItem label="备注" prop="description">
        <Input
          style="width:300px"
          type="textarea"
          :rows="6"
          v-model="pointForm.description"
          :maxlength="500"
          placeholder="备注最多输入500个字"
        />
      </FormItem>
      <FormItem style="text-align:center">
        <Button
          size="large"
          :to="{name: 'QuestionCheckPointManage',query:{parent_id:$route.query.parent_id}}"
        >返回</Button>
        <Button
          size="large"
          style="margin: 0 15px;"
          type="primary"
          @click="submitForm('pointForm')"
        >保存并返回</Button>
      </FormItem>
    </Form>
  </div>
</template>
<script>
export default {
  name: "QuestionCheckPointEdit",
  data() {
    return {
      id: "",
      parent_id: 0,
      parent_name: "",
      pointForm: {
        name: "",
        description: ""
      },
      ruleValidate: {
        name: [{ required: true, message: "考点名称必须填写", trigger: "blur" }]
      }
    };
  },
  async created() {
    this.parent_id = this.$route.query.parent_id || 0;
    this.parent_name = this.$route.query.parent_name || "作为一级考点";
    this.id = this.$route.query.id;
    await this.getData();
  },
  methods: {
    async getData() {
      let id = this.id;
      if (!id) {
        return;
      }
      let data = await this.$http.get("/api/exam/point/" + id);
      this.pointForm.name = data.name;
      this.pointForm.description = data.description;
    },
    async submitForm(ref) {
      this.$refs[ref].validate(async valid => {
        if (!valid) {
          return;
        }
        let data = {
          name: this.pointForm.name,
          description: this.pointForm.description
        };
        if (this.id) {
          await this.$http.put("/api/exam/point/" + this.id, data);
          this.$Message.saveSuccess();
        } else {
          data.parent_id = this.parent_id;
          await this.$http.post("/api/exam/point", data);
          this.$Message.createSuccess();
        }
        this.$router.push({
          name: "QuestionCheckPointManage",
          query: { parent_id: this.parent_id }
        });
      });
    }
  }
};
</script>